module.exports = __webpack_public_path__ + "static/media/Artboard7.cbeb5622.png";